import { MatSnackBar } from '@angular/material/snack-bar'
import { Router } from '@angular/router'

import { KPI_DASHBOARD_NOT_FOUND_MESSAGE } from '../../services/kpi-dashboard/kpi-dashboard.service'
import {
  isKpiCustomError,
  CustomErrorCode,
} from '../../util/throwIfCustomError'

/** 削除済み・閲覧不可のダッシュボードを通知し、履歴を残さず一覧へ戻す。 */
export function handleDashboardNotFound(
  error: unknown,
  router: Router,
  snackBar: MatSnackBar,
): boolean {
  if (
    !isKpiCustomError(error, CustomErrorCode.NOT_FOUND, [
      KPI_DASHBOARD_NOT_FOUND_MESSAGE,
    ])
  )
    return false
  snackBar.open(
    'ダッシュボードが見つからないか、閲覧権限がありません。',
    '閉じる',
    { duration: 5000 },
  )
  router.navigate(['/kpi-dashboards'], { replaceUrl: true })
  return true
}
